import PropTypes from 'prop-types';
import noop from '../../../../utils/noop';
import { PLAN_ROW_ITEM_PROP_TYPES } from '../plan-row-item/constants';

export const MOBILE_PLAN_PROPTYPES = {
  captions: PropTypes.shape({
    pricing: PropTypes.shape({
      first: PropTypes.string,
      second: PropTypes.string,
      period: PropTypes.string,
    }),
    name: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.string,
    label: PropTypes.string,
  }),
  availabilities: PropTypes.arrayOf(
    PropTypes.shape({
      ...PLAN_ROW_ITEM_PROP_TYPES,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  collapseOpenText: PropTypes.string,
  collapseHiddenText: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  withExtraPrice: PropTypes.bool,
  highlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  collapsed: PropTypes.bool,
  onPlanSelect: PropTypes.func,
  onCollapseClick: PropTypes.func,
};
